module.exports = __webpack_public_path__ + "img/enemy_move_stand.1219b517.svg";